
import axiosInstance from '../../config'; //axios instance with pre-configuration

export const exitRowPositionService = async (token, data) => {

    try {

        const response = await axiosInstance.post(

            '/ui/symbol_detail',

            data,

            {

                headers: {

                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",

                },

            }

        );
       


        return {

            data: response.data,

            status: response.status,

        };

    }
    catch (error) {


    //  console.log("postion exit res", error.response)
        return {

            error: true,

            message: error.response?.data || error.message,

            status: error.response?.status || 500

        };

    }

};